import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"
import { Button } from "../../component/button.tsx"
import { useLazyProfileQuery, useLoginMutation } from "./service.ts"

const LoginError = () => <div>Неверно указан логин или пароль</div>

export const LoginForm = () => {
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const [login, { isLoading }] = useLoginMutation()
  const [getProfile] = useLazyProfileQuery()
  const navigate = useNavigate()

  const handleSubmit = async (e: { preventDefault: () => void }) => {
    e.preventDefault()
    try {
      await login({ username, password }).unwrap()
      await getProfile().unwrap()
      navigate("/")
    } catch (err) {
      toast(LoginError, { type: "error", autoClose: 10000 })
      console.error("Failed to login", err)
    }
  }

  return (
    <div className="hero bg-base-200 min-h-screen">
      <div className="hero-content flex-col">
        <h1 className="text-3xl font-bold text-center">Вход в аккаунт</h1>
        <div className="card bg-base-100 w-full max-w-sm shrink-0 shadow-2xl">
          <form className="card-body" onSubmit={handleSubmit}>
            <div className="form-control">
              <label className="label">
                <span className="label-text">Имя пользователя</span>
              </label>
              <input
                type="text"
                placeholder="Имя пользователя"
                className="input input-bordered"
                required
                value={username}
                onChange={e => setUsername(e.target.value)}
              />
            </div>
            <div className="form-control">
              <label className="label">
                <span className="label-text">Пароль</span>
              </label>
              <input
                type="password"
                placeholder="Пароль"
                className="input input-bordered"
                required
                value={password}
                onChange={e => setPassword(e.target.value)}
              />
            </div>
            <div className="form-control mt-6">
              <Button type="submit" isProcessing={isLoading} className="btn-primary">
                Войти
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
